<template>
  <el-image
    :src="src"
    :preview-src-list="previewList"
    :preview-teleported="true"
    @click.native="handleClick"
    v-bind="$attrs"
    class="s-img"
  />
</template>

<script>
export default {
  name: 'SImg',
  props: {
    src: {
      type: String,
      default: '',
    },
    previewSrcList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    previewList() {
      return this.previewSrcList.length ? this.previewSrcList : [this.src]
    },
  },
  methods: {
    handleClick() {
      // 可选扩展点击事件
      this.$emit('preview', this.src)
    },
  },
}
</script>

<style scoped>
.s-img {
  cursor: pointer;
}
</style>
